import axios from "axios";
import apiURI from "./Api";

export default class ExtracoinService {
  async postTransferIntent(token, amount, fromUsername, toUsername) {
    const bodyJson = {
      amount: amount,
      userFrom: { username: fromUsername },
      userTo: { username: toUsername },
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/walletextracoin/transferintent`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getIntentsFrom(token, username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/walletextracoin/getiintents/from/${username}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getIntentsTo(token, username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/walletextracoin/getiintents/to/${username}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postFromAgree(token, username, transferIntent, passwordfinantial) {
    const bodyJson = {
      idtransferintent: transferIntent,
      passwordfinantial: passwordfinantial,
      userFrom: { username: username },
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/walletextracoin/transfer/agreement/from`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postToAgree(token, username, transferIntent, code, passwordfinantial) {
    const bodyJson = {
      code: code,
      idtransferintent: transferIntent,
      passwordfinantial: passwordfinantial,
      userTo: { username: username },
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/walletextracoin/transfer/agreement/to`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
